
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"1.3","stroke-linejoin":"round","d":"M3.375 1.35h7.3a2 2 0 012 2v5.3a2 2 0 01-2 2H7.6l-2.77 2.424a.5.5 0 01-.83-.376V10.65h-.625a2 2 0 01-2-2v-5.3a2 2 0 012-2z"}})])
          )
        }
      }
    